import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { getMisc } from "../../../apiclients/streamsapi_bridge";
import refresh from "../../images/refresh.svg";
// import AddExternalNumbr from "../../../views/popups/users/AddExternalNumber";
import PopupLoader from "../../../views/popups/PopupLoader";
// import EditExternalNumbr from "../../../views/popups/users/EditExternalNumber";
// import DeleteExternalNumber from "../../../views/popups/users/DeleteExternalNum";
import UserResetPassword from "../../../views/popups/users/UserResetPassword";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import { MDBSelect } from "mdb-react-ui-kit";
import { call_routing_service_id } from "../../../apiclients/apiurls";
const GeneralSettings = ({
  register,
  errors,
  setValue,
  userserviceid,
  timezone,
  externalNumbers,
  useragent,
  setSuccessMessage,
  getValues,
  setError,
  checkAvailable,
  clearErrors,
  setErrorMessage,
  isDisabled,
  fields,
  handleServicePlanChange,
  setchangePlan,
  changePlan,
  watch,
  isstreamsReq,
  isFiveNineAcc
}) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [services, setServices] = useState([]);
  const [timezones, setTimeZones] = useState([]);
  const [autoext, setAutoext] = useState(false);
  const [checkAvailbility, setCheckAvailbility] = useState(false);
  const [servicesuit, setServiceSuit] = useState(0);
  const [timezoneid, setTimeZoneId] = useState(0);
  // const [existexternalNumbers, setExistExternalNumbers] = useState([]);
  // const [newNumber, setNewNumber] = useState({});
  // const [editNumber, setEditNumber] = useState({});
  // const [AddExternalNumber, setAddExternalNumbers] = useState(false);
  // const [EditExternalNumber, setEditExternalNumbers] = useState(false);
  // const [extnumdetails, setExtNumDetails] = useState({});
  // const [finalEditExternal, setFinalEditExternal] = useState([]);
  const [agentid, setAgentID] = useState("");
  // const toggleExternalNumbers = () => setAddExternalNumbers(!AddExternalNumber);
  // const [isdeleteNumber, setIsDeleteNumbers] = useState(false);
  // const dtogglePopup = () => setIsDeleteNumbers(!isdeleteNumber);
  // const [deleteEXNumber, setDeleteEXNumber] = useState({});
  // const [newExternalNum, setNewExternalNum] = useState({});
  // const [isExternalModify, setIsExternalModify] = useState(false);
  // const [deleteExternalFlag, setDeleteExternalFlag] = useState(false);
  const [ResetPassword, setResetPassword] = useState(false);
  const ResetPasswordToggle = () => setResetPassword(!ResetPassword);
  const [extensionFlag, setExtensionFlag] = useState(true);
  const [defaultExtension, setDefaultExtension] = useState(0);
  const [allLocations, setAllLocations] = useState([]);
  const [billingGroupList, setBillingGroupList] = useState([]);
  const resetPasswordRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);
  const extensionValue = watch("extension") === 0 ? "" : watch("extension");

  function handleClick() {
    resetPasswordRef.current.click();
  }
  let apiRequest = false;

  // useEffect(() => {
  //   if (extensionFlag && getValues("extension") != 0) {
  //     setDefaultExtension(getValues("extension"));
  //     setExtensionFlag(false);
  //   }
  // }, [extensionFlag, getValues("extension")]);

  // const toggleEditExternalNumbers = (title, number, id) => {
  //   setExtNumDetails({
  //     id: id,
  //     title: title,
  //     number: number,
  //   });
  //   setEditExternalNumbers(!EditExternalNumber);
  // };

  // function createFinalAddList() {}

  // function createFinalEditList() {}

  // function createFinalRemoveList() {}
  async function fetchData() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      {
        misc: ["services", "term", "all_locations", "billinggroups"], agentid: useragent
      }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    //setServices(tdata.misc.services);
    const transformedBillingGroups = (tdata.misc.services || []).map(
      (entry) => ({ text: entry.name, value: parseInt(entry.id) })
    );
    console.log(
      "services list :::::::::::::: " + JSON.stringify(transformedBillingGroups)
    );
    setServices(transformedBillingGroups);
    setAllLocations(
      tdata.misc.all_locations.map((item) => ({
        text: item.loc_name,
        value: parseInt(item.loc_id, 10), // Ensure id is a number
      }))
    );
    setBillingGroupList(
      (tdata?.misc?.billinggroups ?? []).map((item) => ({
        text: item.groupname,
        value: parseInt(item.groupid, 10), // Ensure id is a number
      }))
    );
  }
  async function fetchTimeZoneData() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["timezone"] }
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    //setServices(tdata.misc.services);

    let timezoneOptions = tdata?.misc?.timezone ?? [];
    setTimeZones(
      timezoneOptions.map((item) => {
        const [location, offset] = item.timezone.split("  ");
        return {
          text: location,
          secondaryText: offset,
          value: parseInt(item.tid),
        };
      })
    );
  }
  useEffect(() => {
    if (userserviceid && userserviceid !== 0) {
      setServiceSuit(userserviceid);
    }
    if (timezone) {
      setTimeZoneId(timezone);
    }
    setchangePlan(false);
  }, [userserviceid, timezone, changePlan]);

  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    fetchTimeZoneData();
  }, []);

  // useEffect(() => {
  //   if (editNumber) {
  //     createFinalAddList();
  //   }
  // }, [newNumber]);

  // useEffect(() => {
  //   if (editNumber) {
  //     createFinalEditList();
  //   }
  // }, [editNumber]);

  // useEffect(() => {
  //   if (externalNumbers) {
  //     if (externalNumbers.length > 0) {
  //       setExistExternalNumbers(externalNumbers);
  //     } else {
  //       const defaultExternal = [
  //         {
  //           title: "Cell Phone",
  //           externum: "",
  //           id: 0,
  //         },
  //       ];
  //       setExistExternalNumbers(defaultExternal);
  //     }
  //   }
  // }, [externalNumbers]);

  useEffect(() => {
    if (useragent) {
      setAgentID(useragent);
    }
  }, [useragent]);

  useEffect(() => {
    if (checkAvailable) {
      setCheckAvailbility(checkAvailable);
    }
  }, [checkAvailable]);

  // useEffect(() => {
  //   if (isExternalModify) {
  //     modifyExistingExternalNum();
  //   }
  // }, [isExternalModify]);

  // function modifyExistingExternalNum() {
  //   let updatedNum = [];
  //   //alert(JSON.stringify(newExternalNum) + "  :::: newExternalNum")
  //   const extrnalNum = existexternalNumbers.filter(
  //     (item) => item.id !== newExternalNum.id
  //   );
  //   if (deleteExternalFlag) {
  //     updatedNum = [...extrnalNum];
  //     setDeleteExternalFlag(false);
  //   } else {
  //     updatedNum = [...extrnalNum, newExternalNum];
  //   }
  //   setIsExternalModify(false);
  //   setExistExternalNumbers(updatedNum);
  // }

  async function checkAvailability(e) {
    e.preventDefault();
    e.stopPropagation();
    apiRequest = true;
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { check_ext: parseInt(e.target.value) }
    );
    console.log(response);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    if (apiRequest) {
      if (tdata.check_ext) {
        setCheckAvailbility(true);
        setError("extension", { message: "Extension is available" });
      } else {
        setCheckAvailbility(false);
        setError("extension", { message: "Extension is not available" });
      }
      apiRequest = false;
    } else {
      clearErrors("extension");
      setCheckAvailbility(false);
    }
    console.log(tdata);
  }

  const parseToInteger = (value, fieldname) => {
    if (value !== "") {
      setValue(fieldname, parseInt(value), { shouldDirty: true });
    }
  };
  // function deleteNumber(number, id) {
  //   dtogglePopup();
  //   setDeleteEXNumber({
  //     id: id,
  //     phNum: parseInt(number),
  //   });
  // }

  const shouldHideSection = (name) => {
    if (fields.length > 0) {
      return fields.some((field) => field.name === name);
    }
  };

  // Seat Plan dropdown source: if the current service id isn't one of the Misc
  // "services" options, but matches call_routing_service_id, add a synthetic
  // "Call Routing" option so MDBSelect can show it as the selected value.
  const hasMatchingService = services.some(
    (item) => parseInt(item.value) === parseInt(servicesuit)
  );
  const seatPlanOptions =
    !hasMatchingService && parseInt(servicesuit) === call_routing_service_id
      ? [...services, { text: "Call Routing", value: call_routing_service_id }]
      : services;
  return (
    <>
      <div className="general-settings">{t("general")}</div>
      <div className="ps-0">
        <div className="add-numbermain">
          <div className="tel-numbers">{t("Name")}</div>
          <div className="flex-column-sm d-flex w-30">
            <div className="me-2 w-100">
              <label className="float-left md-font">{t("firstName")}</label>
              <input
                // label={t("firstName")}
                maxLength={30}
                type="text"
                className="w-100"
                {...register("fname", { required: "First Name is required" })}
              />
              {errors.fname && (
                <p className="text-danger">{errors.fname.message}</p>
              )}
            </div>
            <div className="w-100">
              <label className="float-left md-font">{t("lastName")}</label>
              <input
                // label={t("lastName")}
                maxLength={20}
                type="text"
                {...register("lname", { required: "Last name is required" })}
                className="w-100"
              />
              {errors.lname && (
                <p className="text-danger">{errors.lname.message}</p>
              )}
            </div>
          </div>
        </div>
        {(!shouldHideSection("extension") && !isFiveNineAcc ) && (
          <div className="add-numbermain">
            <div className="tel-numbers">{t("extension")}</div>
            <div className="d-flex w-30">
              <div className="phoneselect w-100">
                <div
                  {...(isstreamsReq
                    ? {
                      title:
                        "User does not have permission to edit",
                      className: "disabled-form cursor-notAllowed",
                      onClick: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      },
                    }
                    : {})}
                >
                  <input
                    type="text"
                    className="w-100"
                    maxLength={5}
                    value={extensionValue}
                    {...register("extension", {
                      setValueAs: (value) => Number(value),
                      required: "Extension is required",
                      minLength: {
                        value: 3,
                        message: "Extension must be at least 3 characters",
                      },
                      maxLength: {
                        value: 5,
                        message: "Extension must not exceed 5 characters",
                      },
                    })}
                    onKeyPress={(event) => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      if (e.target.value !== "") {
                        if (
                          e.target.value.length >= 3 &&
                          e.target.value.length <= 5
                        ) {
                          if (
                            parseInt(defaultExtension) ===
                            parseInt(e.target.value)
                          ) {
                            clearErrors("extension");
                          } else {
                            checkAvailability(e);
                          }
                        } else {
                          clearErrors("extension");
                          setCheckAvailbility(false);
                          apiRequest = false;
                        }
                        setValue("extension", parseInt(e.target.value), {
                          shouldDirty: true,
                        });
                      } else {
                        setValue("extension", "", {
                          shouldDirty: true,
                        });
                        clearErrors("extension");
                        setCheckAvailbility(false);
                        apiRequest = false;
                      }
                    }}
                  />
                </div>
                {errors.extension && (
                  <>
                    {checkAvailbility ? (
                      <p style={{ color: "Green" }} className="clr-red">
                        {errors.extension.message}
                      </p>
                    ) : (
                      <p className="text-danger">{errors.extension.message}</p>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        )}
        <div className="add-numbermain">
          <div className="tel-numbers">{"Email Address"}</div>
          <div className="d-flex w-30">
            <div className="phoneselect w-100">
              <input
                type="text"
                className="w-100"
                {...register("emailid", {
                  required: "Email Address is required",
                   setValueAs: (value) => value?.trim(),
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid email address",
                  },
                })}
              />
              {errors.emailid && (
                <p className="text-danger">{errors.emailid.message}</p>
              )}
            </div>
          </div>
        </div>
        <div className={`add-numbermain ${isFiveNineAcc ? "disabled-form cursor-notAllowed" : ""}`}>
          <div className="tel-numbers">{t("SeatPlan")}</div>
          <div className="d-flex w-30">
            <div
              {...(isstreamsReq
                ? {
                  title:
                    "User does not have permission to edit",
                  className: "disabled-form cursor-notAllowed w-100",
                  onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  },
                }
                : {className : "w-100"})}
              >
            <div className="phoneselect w-100">
           
              <MDBSelect
                className="w-100"
                value={servicesuit}
                disabled = {isFiveNineAcc}
                data={seatPlanOptions}
                search
                onChange={(e) => {
                  if (e && e.value && parseInt(servicesuit) !== parseInt(e.value)) {
                    // e.preventDefault();
                    setValue("seatplan_info.serviceid", parseInt(e.value), {
                      shouldDirty: true,
                    });
                    setServiceSuit(parseInt(e.value));
                    handleServicePlanChange(e.value);
                  }
                }}
              />
              </div>
              {/* {services &&
                  services.map((item) => (
                    <>
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    </>
                  ))} */}
              {/* </MDBselect> */}
              {/* {errors.serviceid && <p className="text-danger">{errors.serviceid.message}</p>} */}
            </div>
          </div>
        </div>

        <div className={`add-numbermain ${isFiveNineAcc ? "disabled-form cursor-notAllowed" : ""}`}>
          <div className="tel-numbers">{t("location")}</div>
          <div className="d-flex w-30">
            <div
              {...(isstreamsReq
                ? {
                  title:
                    "User does not have permission to edit",
                  className: "disabled-form cursor-notAllowed w-100",
                  onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  },
                }
                : { className: "w-100" })}
            >
              <div className="phoneselect w-100">

                <MDBSelect
                  className="w-100"
                  name="San Jose"
                  search
                  disabled = {isFiveNineAcc}
                  data={allLocations}
                  // {...register("loc_id", {
                  //   setValueAs: (value) => Number(value),
                  // })}
                  value={parseInt(watch("loc_id"))}
                  onChange={(e) => {
                    if (e && e.value) {
                      setValue("loc_id", parseInt(e.value), {
                        shouldDirty: true,
                      });
                    }
                  }}
                />
                {/* {allLocations &&
                  allLocations.map((loc) => (
                    <option value={parseInt(loc.loc_id)}>{loc.loc_name}</option>
                  ))} */}
              </div>
            </div>
          </div>
        </div>
        {!isFiveNineAcc &&
          <div className="add-numbermain">
            <div className="tel-numbers">{t("timezone")}</div>
            {/* <div > */}
            {/* <select
            className="form-control form-select selectname w-100"
            name="San Jose"
            value={timezoneid}
            data={timezones}
            search
            onChange={(e) => {
              if (e && e.value) {
                setValue("tzid", parseInt(e.value), {
                  shouldDirty: true,
                });
                setTimeZoneId(parseInt(e.value));
              }
            }}
          />
          {/* {timezones &&
              timezones.map((item) => (
                <>
                  <option key={item.tid} value={item.tid}>
                    {item.timezone}
                  </option>
                </>
              ))}
          </select> */}
            <div className="w-30">

              <MDBSelect
                style={{ width: "100%" }}
                search
                label={false}
                data={timezones}
                value={timezoneid}
                onChange={(e) => {
                  if (e && e.value) {
                    const selectedValue = parseInt(e.value);
                    setValue("tzid", selectedValue, {
                      shouldDirty: true,
                    });
                    setTimeZoneId(selectedValue);
                  }
                }}
              />
            </div>
            {/* </div> */}
          </div>
        }

        <div className={`add-numbermain ${isFiveNineAcc ? "disabled-form cursor-notAllowed" : ""}`}>
          <div className="tel-numbers">{t("billingGroup")}</div>
          <div className="d-flex w-30">
            <div
              {...(isstreamsReq
                ? {
                  title:
                    "User does not have permission to edit",
                  className: "disabled-form cursor-notAllowed w-100",
                  onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  },
                }
                : { className: "w-100" })}
            >
              <div className="phoneselect w-100">

                <MDBSelect
                  className="w-100"
                  name="San Jose"
                  disabled = {isFiveNineAcc}
                  data={billingGroupList}
                  value={parseInt(watch("billing_grp"))}
                  search
                  onChange={(e) => {
                    if (e && e.value) {
                      setValue("billing_grp", parseInt(e.value), {
                        shouldDirty: true,
                      });
                    }
                  }}
                />
                {/* {billingGroupList &&
                  billingGroupList.map((bgrp) => (
                    <option value={bgrp.groupid}>{bgrp.groupname}</option>
                  ))}
              </MDBSelect> */}
              </div>
            </div>
          </div>
        </div>
        <div className="add-numbermain">
          <div className="tel-numbers">{t("ResetPassword")}</div>

          <div
            {...(isDisabled && !(isstreamsReq)
              ? {
                onClick: (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                },
              }
              : {
                onClick: ResetPasswordToggle,
              })}
          >
            <img
              src={refresh}
              className={`cursor-pointer ${isDisabled && !(isstreamsReq) && "disabled-form cursor-notAllowed"
                }`}
            />
          </div>
        </div>

        {/* <div className="mt-4 d-flex justify-content-between align-items-center">
          <div className="general-settings">{t("ExternalNumbers")}</div>
          <div>
            <MDBBtn
              onClick={(e) => {
                e.preventDefault(); // Prevent the form submission
                toggleExternalNumbers(); // Open the modal
              }}
            >
              <MDBIcon fas icon="plus" size="sm" /> {t("addExternal")}
            </MDBBtn>
          </div>
        </div>
        <MDBTable className="mt-2">
          <MDBTableHead>
            <tr>
              <th scope="col" className="w-20">
                Name
              </th>
              <th scope="col" className="w-70">
                Number
              </th>
              <th scope="col" className="text-center w-10">
                Remove
              </th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            {existexternalNumbers &&
              existexternalNumbers.map((externum) => (
                <>
                  <tr
                    onClick={(e) => {
                      e.preventDefault(); // Prevent the form submission
                      toggleEditExternalNumbers(
                        externum.title,
                        externum.phNumber,
                        externum.id
                      ); // Open the modal
                    }}
                  >
                    <td scope="row">{externum.title}</td>
                    <td>{externum.phNumber}</td>
                    <td className="text-center">
                      {externum.title !== "Cell Phone" && (
                        <i
                          className="fas fa-xmark ms-4 text-primary"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation(); // Stop event propagation
                            deleteNumber(externum.phNumber, externum.id);
                          }}
                        ></i>
                      )}
                    </td>
                  </tr>
                </>
              ))}
          </MDBTableBody>
        </MDBTable> */}
      </div>

      {/* {AddExternalNumber && (
        <PopupLoader
          //size="lg"
          //className="modal-lg"
          title={"Add External Number"}
          content={
            <AddExternalNumbr
              existexternalNumbers={existexternalNumbers}
              finalEditExternal={finalEditExternal}
              useragent={useragent}
              setNewExternalNum={setNewExternalNum}
              setIsExternalModify={setIsExternalModify}
              onClose={toggleExternalNumbers}
              setSuccessMessage={setSuccessMessage}
              setErrorMessage={setErrorMessage}
            />
          }
          onShow={setAddExternalNumbers}
          onClose={toggleExternalNumbers}
        />
      )}
      {EditExternalNumber && (
        <PopupLoader
          // size="lg"
          // className="modal-lg"
          title={"Edit External Number"}
          content={
            <EditExternalNumbr
              extnumdetails={extnumdetails}
              existexternalNumbers={existexternalNumbers}
              finalEditExternal={finalEditExternal}
              setEditNumber={setEditNumber}
              useragent={useragent}
              setNewExternalNum={setNewExternalNum}
              setIsExternalModify={setIsExternalModify}
              setSuccessMessage={setSuccessMessage}
              setErrorMessage={setErrorMessage}
              onClose={toggleEditExternalNumbers}
            />
          }
          onShow={setEditExternalNumbers}
          onClose={toggleEditExternalNumbers}
        />
      )}

      {isdeleteNumber && (
        <PopupLoader
          title={"Delete External Number"}
          content={
            <DeleteExternalNumber
              useragent={useragent}
              deleteEXNumber={deleteEXNumber}
              setNewExternalNum={setNewExternalNum}
              setIsExternalModify={setIsExternalModify}
              setDeleteExternalFlag={setDeleteExternalFlag}
              onClose={dtogglePopup}
              setSuccessMessage={setSuccessMessage}
              setErrorMessage={setErrorMessage}
            />
          }
          onShow={setIsDeleteNumbers}
          onClose={dtogglePopup}
        />
      )} */}
      {ResetPassword && (
        <PopupLoaderNew
          title={t("ResetPassword")}
          content={
            <UserResetPassword
              useragent={useragent}
              setSuccessMessage={setSuccessMessage}
              setErrorMessage={setErrorMessage}
              onClose={ResetPasswordToggle}
              ref={resetPasswordRef}
              setIsloading={setisLoading}
            />
          }
          onShow={setResetPassword}
          onClose={ResetPasswordToggle}
          onSave={handleClick}
          isloading={isLoading}
          flag={6}
        />
      )}
    </>
  );
};

export default GeneralSettings;
